import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';

import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
  selector: 'app-dieuhanh-thietlapngaytaoedit',
  templateUrl: './thietlapngaytaoedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./thietlapngaytaoedit.component.scss'],
    providers: [ListService, Repository]
})


export class thietlapngaytaoeditComponent implements OnInit {
  doanhnghiepid: string = null;
  public ngaysinh: Date = null;
  public ngaycmnd: Date = null;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputhangbaohiems: any;
  inputphongbans: any;
  inputhangxes: any;
  inputkhachhangs: any;
  inputmausacs: any;
  inputmodels: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, NhanSuId: null, LyDo: null, SoBuoi: null
    , NgayNhap: null, TrangThai: null, GhiChu: null
    ,Created: null, Modified: null, CreatedBy: null, ModifiedBy: null

  };       
    nhomdtid:string=null;
  hoatdong: string = null;
  inputnhacungcaps: any = [
    { Ten_Doi_Tuong: "Cá nhân", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Tổ chức", Ma_Doi_Tuong: '1', Id: true },
  ];

  dstrangthais: any = [
    { Ten: 'Nghỉ học', Id: 0 },
    { Ten: 'Học bình thường', Id: 1 },
    { Ten: 'Bảo lưu', Id: 2 }
    
  ];

  inputthus: any = [
    { Ten: 'Thứ 2', Id: 2 },
    { Ten: 'Thứ 3', Id: 3 },
    { Ten: 'Thứ 4', Id: 4 },
    { Ten: 'Thứ 5', Id: 5 },
    { Ten: 'Thứ 6', Id: 6 },
    { Ten: 'Thứ 7', Id: 7 },
    { Ten: 'Chủ nhật', Id: 8 }
  ];

  inputgioitinhs: any = [
    { Ten_Doi_Tuong: "Nữ", Ma_Doi_Tuong: '0', Id: false },
    { Ten_Doi_Tuong: "Nam", Ma_Doi_Tuong: '1', Id: true },
  ];

  inputloais: any = [
    { text: "Nhân công", value: 0 },
    { text: "Vật tư sơn", value: 1 },
  ];

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();

  Password: string = null;
  PasswordNew: string = null;
  PasswordConfirm: string = null;
  username: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  tieudectmt: any;
  tieudectmtplace: any;
  hosoid: string;
  TaiKhoan: string;
 
  loadDataInit(nhomdoituongid: string, id: string, donviid: string, rowdata: any, hocvienid: string) {

    this.doituongSelect = {
      Id: null, NhanSuId: null, LyDo: null, SoBuoi: null
      , NgayNhap: null, TrangThai: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };

    this.hosoid = hocvienid;
    this.doituongSelect.NhanSuId = hocvienid;
          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            this.username = this.currentUser.user_name;
            this.doituongSelect.Created = new Date();
            this.doituongSelect.CreatedBy = this.currentUser.user_name;
            this.doituongSelect.Modified = new Date();
            this.doituongSelect.ModifiedBy = this.currentUser.user_name;


            this.repo.postRequest("api/Login/chotsobuoihocbyid/", this.doituongSelect)
              .subscribe(response => {
                if (response != null) {
                  this.doituongSelect.Created = new Date(response.Created);
                  this.doituongSelect.CreatedBy = response.CreatedBy;
                  this.doituongSelect.SoBuoi = response.SoBuoi;
                  this.doituongSelect.GhiChu = response.GhiChu;
                  this.doituongSelect.Id = response.Id;
                  this.doituongSelect.NhanSuId = response.NhanSuId; 
                  this.doituongSelect.Modified = new Date();
                  this.doituongSelect.ModifiedBy = this.currentUser.user_name;
                  }

              });

            //var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            //if (giatri != null && giatri.length > 0) {
            //  if (giatri[0].Them == true)
            //    this.quyen_them = true;
            //  else
            //    this.quyen_them = false;
            //  if (giatri[0].Sua == true)
            //    this.quyen_sua = true;
            //  else
            //    this.quyen_sua = false;
            //  if (giatri[0].Xoa == true)
            //    this.quyen_xoa = true;
            //  else
            //    this.quyen_xoa = false;
            //}

            

          }    

       
    
       
   }
   
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    public closeModal(){
        this.save.emit(null);
  }

  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  ThucHien() {
    
    if (this.doituongSelect.Created == null) {
      swal('Lỗi!', "Vui lòng nhập ngày tạo.", 'error');
      return;
    }
    if (this.doituongSelect.SoBuoi == null) {
      swal('Lỗi!', "Vui lòng nhập số buổi.", 'error');
      return;
    }
    
    this.repo.postRequest("api/Login/chotsobuoihoc/", this.doituongSelect
    )
      .subscribe(response => {
        if (response != null && response.match('OK_')) {
          swal('Saved!', 'Lưu thành công!.', 'success');
          this.save.emit(this.doituongSelect);
        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }

  XoaChotBuoiHoc() {

   
    this.repo.postRequest("api/Login/xoachotsobuoihocbyid/", this.doituongSelect
    )
      .subscribe(response => {
        if (response != null && response.match('OK')) {
          swal('Saved!', 'Lưu thành công!.', 'success');
          this.save.emit(this.doituongSelect);
        }
        else if (response != null) {
          swal('Lỗi!', response, 'error');
        }

        console.log(response);

      });
  }
   
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
  indexdt: number;
  cotdt: string;


   


}
